<template>
  <div>
    <vs-card class="p-1">
      <div>
        <div class="vx-row">
          <div class="vx-col w-2/3">
            <label class="vs-input--label">ค้นหาข้อมูลผู้คำ้ประกัน <small class="text-grey">(โดยสามารถค้นหาได้จาก
              เลขที่บัตรประจำตัวประชาชน หรือชื่อ-นามสกุล)</small> <small class="ml-2"
                                                                         v-if="totalMatched > maxOptions">
              #แสดงผลเพียง {{ maxOptions }} รายการจาก {{ totalMatched }} รายการที่พบ
            </small></label>

            <v-select
              v-model="form.surety"
              :filterable="false"
              :options="filteredSureties"
              :clearable="true"
              @search="onSearchSurety"
              label="label"
            >
            </v-select>

          </div>
          <div class="vx-col w-1/3 mt-5" style="display: flex; justify-content: flex-end;">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-list"
                       @click="routerList()">รายการผู้คำ้ประกัน
            </vs-button>
            <vs-button color="success" type="filled" icon-pack="feather" icon="icon-user-plus" @click="routerAdd()">
              สร้างผู้คำ้ประกัน
            </vs-button>
          </div>
        </div>
      </div>
      <vs-divider class="mb-3 mt-3"></vs-divider>
      <div v-if="_surety">
        <div class="vx-row pb-1">
          <div class="vx-col w-2/3">
            <p class="text-2xl align-middle">{{ _surety.fullName }}</p>
            <div class="text-grey text-sm icon-text-container d-flex align-items-center ">
              <span class="mr-2"><vs-icon icon="mail"></vs-icon></span>
              <span class="mr-2 vertical-align3">{{ _surety.email }}</span>
              <span class="mr-2"><vs-icon icon="phone_iphone"></vs-icon></span>
              <span class="mr-2 vertical-align3">{{ _surety.mobile }}</span>
              <span class="mr-2"><vs-icon icon="phone"></vs-icon></span>
              <span class="mr-2 vertical-align3">{{ _surety.phone }}</span>
            </div>
          </div>
          <div class="vx-col w-1/3">
            <div class="vx-row">
              <div class="vx-col w-full" style="display: flex; justify-content: flex-end;">
                <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-edit"
                           @click="routerEdit()">แก้ไขข้อมูล
                </vs-button>
              </div>
            </div>
          </div>
        </div>

        <div class="bordered-group vs-card vs-con-block mt-5">
          <div class="vs-card-content">
            <div class="vx-row ">
              <div class="vx-col w-full">
                <vs-table max-items="10" :data="_suretyContracts">
                  <template slot="header">
                    <h6>การคำ้ประกัน</h6>
                  </template>

                  <template slot="thead">
                    <vs-th sort-key="">#</vs-th>
                    <vs-th sort-key="">เลขที่สัญญา</vs-th>
                    <vs-th sort-key="">วันที่สัญญา</vs-th>
                    <vs-th sort-key="">ชื่อสัญญา</vs-th>
                    <vs-th sort-key="">เงินกู้ตามสัญญา</vs-th>
                    <vs-th sort-key="">เงินกู้ตามจริง</vs-th>
                    <vs-th sort-key="">เงินต้นคงเหลือ</vs-th>
                    <vs-th sort-key="">สถานะ</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                      <vs-td :data="index + 1">
                        {{ index + 1 }}
                      </vs-td>
                      <vs-td :data="row.contractNo">
                        <a @click="routerMangeTransaction(row.id)" class="cursor-pointer">{{
                            row.contractNo
                          }} </a><b><u>{{ row.contractSeq }}</u></b>
                      </vs-td>
                      <vs-td :data="row.contractDate">
                        {{ row.contractDate | convYYYYMMDDToDDMMYYYY }}
                      </vs-td>
                      <vs-td :data="row.contractName">
                        <a @click="routerMangeTransaction(row.id)" class="cursor-pointer">{{ row.contractName }} </a>
                      </vs-td>
                      <vs-td :data="row.contractAmount">
                        {{ row.contractAmount | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.loanAmount">
                        {{ row.loanAmount | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.principleRemain">
                        {{ row.principleRemain  | numberFormat }}
                      </vs-td>
                      <vs-td :data="row.contractStatus">
                        <vs-chip :color="row.contractSummarizeStatus | contractSummarizeStatusColor">
                          {{ row  | contractSummarizeStatus }}
                        </vs-chip>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

            <div class="vx-row flex mt-5">
              <div class="vx-col flex-1">
                <label class="vs-input--label">จำนวนสัญญา<span
                  class="ml-1 text-grey text-sm">(เฉพาะสัญญาที่ Active)</span></label>
                <vs-input type="text" v-bind:value="_contractSuretySummary.count" class="w-full" disabled="disabled"/>
              </div>
              <div class="vx-col flex-1">
                <!--                <label class="vs-input&#45;&#45;label">รวมเงินกู้ตามสัญญา (บาท)</label>-->
                <!--                <vs-input type="text" v-bind:value="amount" class="w-full" disabled="disabled"/>-->
              </div>
              <div class="vx-col flex-1">
                <!--                <label class="vs-input&#45;&#45;label">รวมเงินกู้ตามจริง (บาท)</label>-->
                <!--                <vs-input type="text" v-bind:value="amount" class="w-full" disabled="disabled"/>-->
              </div>
              <div class="vx-col flex-1">
                <!--                <label class="vs-input&#45;&#45;label">รวมเงินต้นที่ชำระแล้ว (บาท)</label>-->
                <!--                <vs-input type="text" v-bind:value="amount" class="w-full" disabled="disabled"/>-->
              </div>
              <div class="vx-col flex-1">
                <label class="vs-input--label">รวมเงินต้นคงเหลือ (บาท)</label>
                <vs-input type="text" v-bind:value="_contractSuretySummary.principleRemain  | numberFormat"
                          class="w-full" disabled="disabled"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!_surety">
        <p>กรุณาค้นหาข้อมูล</p>
      </div>
    </vs-card>
    <custom-popup ref="paymentDetailPopup" title="รายละเอียดยอดชำระทั้งหมด"/>
    <custom-popup ref="outstandingBalanceRemainDetailPopup" title="รายละเอียดยอดค้างชำระทั้งหมด"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import {ValidationProvider} from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import {createNamespacedHelpers, mapGetters} from "vuex";
import {IContractStatus} from "@/constants/interface";
import CustomPopup from "@/views/components/custom/Popup.vue";

const {mapActions: mapCustomerActions, mapState: mapCustomerFields} = createNamespacedHelpers('Customer');

export default {
  components: {
    CustomPopup,
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data() {
    return {
      form: {
        surety: null,
      },
      filteredSureties: [],
      totalMatched: 0,
      searchTimeout: null,
      maxOptions: 15,
      debounceTime: 500,
    }
  },
  async created() {
    const vm = this
    const {initializing} = vm
    initializing(true);
    await vm.loadOptions();
    await vm.initData();
    initializing(false);
  },
  computed: {
    ...mapCustomerFields(['status', 'suretySearch']),
    ...mapGetters({
      suretySearchOptions: "Customer/suretySearchOptions",
    }),
    _surety() {
      if (this.suretySearch) {
        let surety = this.suretySearch
        surety = {
          ...surety,
          phone: surety.phone ? surety.phone : '-',
          mobile: surety.mobile ? surety.mobile : '-',
          email: surety.email ? surety.email : '-',
        }
        return surety ? surety : null
      } else {
        return null
      }
    },
    _suretyContracts() {
      if (this.suretySearch) {
        const {suretyContracts} = this.suretySearch
        return suretyContracts
      } else {
        return []
      }
    },
    _contractSuretySummary() {
      if (this.suretySearch) {
        const {suretyContracts} = this.suretySearch
        const filteredSuretyContracts = suretyContracts.filter(res => {
          return res.contractStatus === IContractStatus.approved
        })
        const count = filteredSuretyContracts.length
        const principleRemain = filteredSuretyContracts.reduce((acc, val) => acc + val.principleRemain, 0)
        return {
          count,
          principleRemain,
        }
      } else {
        return {
          count: 0,
          principleRemain: 0,
          // paymentAmount: 0,
          // outstandingBalanceRemain: 0,
        }
      }
    },
  },
  methods: {
    ...mapCustomerActions(['initializing', 'getSuretyOptions', 'getSuretyForSuretySearch']),
    onSearchSurety(searchText) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.suretySearchOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalMatched = matched.length;
        this.filteredSureties = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    async loadOptions() {
      const vm = this
      const {suretySearchOptions} = vm
      const {getSuretyOptions} = vm
      if (suretySearchOptions.length === 0) await getSuretyOptions();

      if (this.suretySearch) {
        const selectedSurety = vm.suretySearchOptions.find(b => b.value ===  this.suretySearch.id);
        await this.onSearchSurety(selectedSurety.label);
      } else {
        await this.onSearchSurety('');
      }
    },
    async initData() {
      const vm = this
      if (this.$route.params.id) {
        const selectedSurety = vm.suretySearchOptions.find(b => b.value ===  this.$route.params.id);
        vm.form = {
          surety: selectedSurety
        }
      } else if (this.suretySearch) {
        const selectedSurety = vm.suretySearchOptions.find(b => b.value ===  this.suretySearch.id);
        vm.form = {
          surety: selectedSurety
        }
      }
    },
    routerList: function () {
      this.$router.push({name: 'customer-surety-list'});
    },
    routerAdd: function () {
      this.$router.push({name: 'customer-surety-add'});
    },
    routerEdit: function () {
      this.$router.push({name: 'customer-surety-edit', params: {id: this._surety.id}})
    },
    routerAddContract: function () {
      this.$router.push({name: 'accounting-contract-add', params: {id: this._surety.id}})
    },
    routerMangeTransaction: function (id) {
      this.$router.push({name: 'accounting-contract-detail', params: {id: id}});
    },
  },
  watch: {
    "form.surety": async function (surety) {
      const suretyId = surety ? surety.id : null
      const vm = this
      const {getSuretyForSuretySearch} = vm // setProcessing,
      await getSuretyForSuretySearch({
        form: {
          id: suretyId
        }
      });
    },
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
}
</script>

<style scoped>
.bordered-group-dotted {
  border: 1px dotted #ddd; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group-dotted-danger {
  border: 1px dotted #ddd; /* Custom border */
  //border: 1px dotted  #FF4D4F; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group-dotted-success {
  border: 1px dotted #ddd; /* Custom border */
  //border: 1px dotted #28C76F; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group {
  border: 1px solid #ddd; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.vertical-align3 {
  vertical-align: 3px;
}
</style>
